import React, { memo, useState, useEffect, useCallback, useRef } from 'react'
import styles from './index.module.less'
import { SlickGridRef } from '../..'
import SlickGridComponent from '../../index'
import { useSetState } from 'ahooks'
import { Column, GridOption } from 'slickgrid-react'
import { Button } from 'antd'

const Index = (props: any) => {
  const [state, setState] = useSetState({
    loading: true,
    height: 400
  })
  const gridOptions: GridOption = {
    // enableSorting: false, // 确保禁用排序功能
    gridWidth: '100%',
    // gridHeight: tableWrapHeight,
    autoEdit: true, // 决定了表格单元格是否在点击后立即进入编辑模式。
    autoCommitEdit: true, // 是否自动提交编辑
    enableFiltering: true, // 启用过滤功能，树结构需要这个属性
    enableTreeData: true, // 启用树状数据，必须启用此标志以使过滤和排序按预期工作
    multiColumnSort: false, // 禁用多列排序，因为树状数据不支持多列排序
    autoResize: {
      container: '#indicator_zjzb_table_container',
      rightPadding: 0,
      bottomPadding: 0,
      calculateAvailableSizeBy: 'container'
    },
    enableAutoResize: true,
    treeDataOptions: {
      identifierPropName: 'id',
      columnId: 'name', // 指定树状数据的列ID
      childrenPropName: 'children', // 指定子项属性名称
      autoApproveParentItemWhenTreeColumnIsValid: true,
      autoRecalcTotalsOnFilterChange: false,
      excludeChildrenWhenFilteringTree: false,
      initialSort: { columnId: 'sort', direction: 'asc' }
    },
  }
  const gridRef = useRef<SlickGridRef>(null)

  const columns: Column[] = [
    {
      id: 'id',
      name: '',
      field: 'id',
      minWidth: 60,
      maxWidth: 70,
      cssClass: 'slickgrid_column_number slickgrid-checkbox-center-cls',
      behavior: "select",
      sortable: true,
    },
    {
      id: 'name',
      field: 'name',
      name: '指标科目',
      minWidth: 360,
      cssClass: 'slickgrid-edit',
      sortable: true,
    },
  ]

  const dataSource = Array.from(Array(100).keys()).map(i => {
    return {
      id: i,
      name: `指标科目${i}`
    }
  })
  const getReactGridInstance = () => gridRef.current?.getReactGridInstance()

  const handleClick = () => {
    setState({
      height: 500
    })
    getReactGridInstance()?.resizerService.resizeGrid(0, { height: state.height, width: '100%' });
  }

  return (<div>
    <div className='flex'>
      <Button className='' onClick={handleClick}>设置500</Button>
    </div>
    <div className={styles['tableWrapper']} style={{ height: `${state.height}px` }} id='indicator_zjzb_table_container'>
      <SlickGridComponent
        loading={false}
        ref={gridRef}
        gridId='indicator_zjzb_grid'
        gridOptions={gridOptions}
        columnDefinitions={columns}
        datasetHierarchical={dataSource}
      />
    </div>
  </div>)
}

export default Index